import { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BookingModel } from 'ts/transfer/interfaces/TransferResultsResponse';
import TransferBookingPreview from './BookingPreview';
import { delay, getBase64Screenshot } from 'utils/utils';
import { submitScreenshots } from 'services/transfer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { useGetPage } from 'hooks/useGetPage';
import { b2b, needToScreenshot } from 'constants/generic';

const SuccessTransferPage: FC = () => {
  const [t] = useTranslation();
  const successRef = useRef<HTMLDivElement>(null);
  
  const [order, setOrder] = useState<BookingModel>();
  const location = useLocation();
  useGetPage('Transfers/BookComplete');

  useEffect(() => {
    if (b2b) {
      if (location.pathname !== `/transfer/success`) {
        return;
      }
    }
    const orderStr = sessionStorage.getItem('transferSuccessOrder');
    if (orderStr) {
      const order = JSON.parse(orderStr);
      setOrder(order);

      (async () => {
        await delay(1000);

        if (needToScreenshot) {
          const image = await getBase64Screenshot(successRef.current);

          submitScreenshots({ screenshots: [], orderId: order.orderId, lastScreenshot: image });
        }
      })();
    }
  }, []); // eslint-disable-line

  return (
    <div className="success page-wrapper" ref={successRef}>
      <div className="title">
        {t('flight.order_summary')} #{order?.orderId}
      </div>

      {order?.statusIsOK ? (
        <div className="text-md mb-20">{t('success')}!</div>
      ) : (
        <div className="mb-20">
          <FontAwesomeIcon className="color-danger mr-5" icon={faExclamationTriangle} />
          <span className="text-md">{t('failed_order')}</span>
        </div>
      )}
      {order?.orderHasBeenPaid && (
        <div className="text-md mb-20">{t('hotel.paid_successfully')}</div>
      )}
      {!!order && (
        <TransferBookingPreview
          bookingModel={order}
          ownerModel={order.owner}
          isSuccess={true}
          tripId=""
          companyId=""
          couponAmount={0}
        />
      )}
    </div>
  );
};

export default withErrorBoundary(SuccessTransferPage, 'SuccessTransferPage');
